{
  "comment": "M10 P1d: the runtime ship size-band table (hull tiers spec §2.1, §2.3). maxLengthM is the asset's bounds length (max.z − min.z) a band reaches; dockMode is how a band docks; bayAccepts maps a bay's socket size to the bands it takes; localWeight is a ship's count against maxRealShips; faStopMaxS is the longest flight-assist stop from top speed a hull of the band may take (D-249: S/M about 3 s; L 6 s [P]; XL none yet); flightPresets fill a def's flight fields through its flightBand; cruiseLagS and cruiseChargeS (M10 P5a7a) are a band's cruise spin-up lag and drive charge hold, absent = reach-travel.json cruise.lagS / chargeS (L sits at today's 1.5 / 1.25 until the W6 flip to the long spool, review F5). Every value is [P].",
  "bands": {
    "S": { "maxLengthM": 25, "dockMode": "bay", "localWeight": 1, "faStopMaxS": 3 },
    "M": { "maxLengthM": 70, "dockMode": "bay", "localWeight": 1, "faStopMaxS": 3 },
    "L": { "maxLengthM": 300, "dockMode": "moor", "localWeight": 2, "faStopMaxS": 6, "cruiseLagS": 1.5, "cruiseChargeS": 1.25 },
    "XL": { "maxLengthM": 800, "dockMode": "station", "localWeight": 4 }
  },
  "bayAccepts": {
    "S": ["S"],
    "M": ["S", "M"],
    "L": ["S", "M", "L"]
  },
  "flightPresets": {
    "L": {
      "maxRateDeg": { "pitch": 10, "yaw": 8, "roll": 15 },
      "maxAngAccelDeg": { "pitch": 25, "yaw": 20, "roll": 35 },
      "faGain": 2,
      "rotGain": 3,
      "boostSpeedMult": 1,
      "boostThrustMult": 1
    }
  }
}
